const locationCodeOrNameFilter = {
  namespaced: true,
  state: {
    data: ""
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    setData(context, value) {
      context.commit("SET_DATA", value);
    }
  },
  getters: {
    data: state => {
      return state.data;
    },
    toParams: state => {
      return [
        {column: "or[location.code]", value: state.data},
        {column: "or[location.name]", value: state.data}
      ];
    }
  }
};
export default locationCodeOrNameFilter;
